import gql from 'graphql-tag'

export default gql`mutation removeProjectInvoice($project_id: String!) {
    removeProjectInvoice(project_id: $project_id) @client
}`